// Должен соответствовать projectName
export const UNIQUE_CONFIG_KEY = 'authentication-frontend';
